import { FC } from 'react';
import { BooleanInput, Create, EditProps, required, SimpleForm, TextInput } from 'react-admin';

export const DesignationCreate: FC<EditProps> = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <BooleanInput source="default" />
    </SimpleForm>
  </Create>
);
